export const BREAKPOINTS = {
  tablet: '600px',
  desktop: '1024px',
  wide: '1440px',
} as const;
